/* eslint-disable no-unused-vars */
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  Add_utr_datails,
  notification_handler,
  populate_rent_data,
  updateMigrateAgreement,
  ApprovedByFinance,
} from "../../Services/Services";
import { setAlert, setRefreshBox } from "../../store/action/action";
import EditIcon from "@mui/icons-material/Edit";
import DialogBoxSBM from "../RentalPortal/DialogBoxSBM";
import Remark from "../RentalPortal/Remark";
function SuperAdminTable({ rows, setRows }) {
  const navigate = useNavigate();
  const { params } = useParams();

  const [ids, setIds] = useState([]);
  const [open, setopen] = useState({ open: false });
  const [agreement, setAgreement] = useState();
  const [agreementData, setAgreementData] = useState([]);
  const [agreementIds, setAgreementIds] = useState([]);
  const [code, setCode] = useState({ open: false });

  const [utr, setUtr] = useState({ utr: "", paymentDate: "" });

  const { auth } = useSelector((s) => s);
  const srm_id = auth.id;
  const role = auth.role;

  const subType = "agreement";

  const [modifyDate, setModifyDate] = useState("");

  const dispatch = useDispatch();

  const renderDetailsButton = (e) => {
    const id = e.id;
    const land_id = e.row.landlord_id;
    const code = e.row.code;
    const modify_date = e.row.modify_date;
    return (
      <>
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{
              backgroundColor: "rgb(103 185 68 / 89%)",
              color: "white",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
            onClick={(event) => {
              event.stopPropagation(); // don't select this row after clicking

              const { type, status } = e.row;

              if (type === "Renewed") {
                if (status === "Deposited" || status === "Terminated") {
                  navigate(`/renewal-view-agreement/${id}`);
                } else if (
                  status === "Sent Back From Sr Manager" ||
                  status === "Sent To Sr Manager" ||
                  status === "Terminated"
                ) {
                  navigate(`/renewal-view-agreement/${id}`);
                } else if (
                  status === "Sent Back From BUH" ||
                  status === "Sent To BUH" ||
                  status === "Terminated"
                ) {
                  navigate(`/BHUapproval-renewal/${id}`);
                } else if (
                  status === "Sent Back From Operations" ||
                  status === "Sent To Operations" ||
                  status === "Terminated"
                ) {
                  navigate(`/operations-approval-renewal/${id}`);
                } else if (
                  status === "Sent Back From Finance Team" ||
                  status === "Sent To Finance Team" ||
                  status === "Approved" ||
                  status === "Terminated"
                ) {
                  navigate(`/finance-approval-renewal/${land_id}`);
                }
              } else if (type === "Terminate") {
                if (
                  status === "Terminated By Manager" ||
                  status === "Terminated By Sr Manager " ||
                  status === "Sent Back From Sr Manager Termination" ||
                  status === "Sent Back From Operations Termination" ||
                  status === "Terminated By Operations" ||
                  status === "Approved for Termination" ||
                  status === "Terminated" ||
                  status === "Terminated By Manager"
                ) {
                  navigate(`/renewal-view-agreement/${id}`);
                } else if (
                  status === "Terminated By Manager" ||
                  status === "Sent Back From Sr Manager" ||
                  status === "Sent To Sr Manager" ||
                  status === "Terminated"
                ) {
                  navigate(`/srManagerApprovalForTerminate/${id}`);
                } else if (
                  status === "Sent Back From Operations" ||
                  status === "Sent To Operations" ||
                  status === "Terminated"
                ) {
                  navigate(`/operations-approval-terminate/${id}`);
                } else if (
                  status === "Deposited" ||
                  status === "Sent Back From Finance Team" ||
                  status === "Sent To Finance Team" ||
                  status === "Approved" ||
                  status === "Terminated" ||
                  status === "Sent Back From Finance Team Termination"
                ) {
                  navigate(`/finance-approval-terminate/${id}`);
                }
              } else if (type === "New" || type === "Migrated") {
                if (
                  status === "Draft" ||
                  status === "Deposited" ||
                  status === "Approved" ||
                  status === "Terminated By Manager"
                ) {
                  navigate(`/managerApproval/${id}`);
                } else if (
                  status === "Sent Back From Sr Manager" ||
                  status === "Sent To Sr Manager" ||
                  status === "Terminated" ||
                  status === "Approved"
                ) {
                  navigate(`/srManagerApproval/${id}`);
                } else if (
                  status === "Sent Back From BUH" ||
                  status === "Sent To BUH" ||
                  status === "Terminated" ||
                  status === "Approved"
                ) {
                  navigate(`/BHUapproval/${id}`);
                } else if (
                  status === "Sent Back From Operations" ||
                  status === "Sent To Operations" ||
                  status === "Terminated" ||
                  status === "Approved"
                ) {
                  navigate(`/operations-approval/${id}`);
                } else if (
                  status === "Sent Back From Finance Team" ||
                  status === "Sent To Finance Team" ||
                  status === "Approved" ||
                  status === "Terminated"
                ) {
                  navigate(`/finance-approval/${land_id}`);
                }
              }
            }}
          >
            View
          </Button>
        </Box>
      </>
    );
  };

  const renderActionButton = (e) => {
    const id = e.row.i;

    const code = e.row.code;
    const modify_date = e.row.modify_date;
    return (
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          width: "100%",
          justifyContent: "center",
        }}
      >
        {e.row.status === "Sent To Finance Team" &&
          e.row.type === "Migrated" && (
            <Grid container>
              <Grid item md={6} sx={{ color: "white !important" }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{
                    backgroundColor: "#62CDFF",
                    color: "white",
                    fontSize: "12px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<EditIcon />}
                  onClick={(event) => {
                    event.stopPropagation(); // don't select this row after clicking
                    id && navigate(`/editAgreement/${id}`, { id });
                  }}
                >
                  Edit
                </Button>
              </Grid>
            </Grid>
          )}
        {e.row.status === "Approved" && e.row.utr_number === null && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{
              backgroundColor: "#62CDFF",
              color: "white",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
            onClick={(event) => {
              setModifyDate(modify_date);
              setCode(code);
              setopen({ open: true, id: id, code });
              setAgreement(e.row);
              event.stopPropagation();
              if (params === "mg-ag") {
                navigate(`/finance-listing/mg-ag`);
              } else if (params === "mg-ag") {
                navigate(`/finance-listing/in-procces-ag`);
              }
            }}
          >
            UTR Number
          </Button>
        )}
        {(e.row.status === "Approved for Termination" ||
          e.row.status === "Terminated") && (
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{
              backgroundColor: "rgb(205 22 239)",
              color: "white",
              fontSize: "12px",
              textTransform: "capitalize",
            }}
            //  startIcon={<EditIcon />}
            onClick={(e) => {
              navigate(`/balance_recovery/${id}`);
            }}
          >
            Deposit Recovery
          </Button>
        )}
      </Box>
    );
  };

  const handleSwitch = (e, data) => {
    if (agreementData.length > 0 && ids.includes(e.target.name)) {
      const filtered = agreementData.filter((item) => item.id !== data.id);
      setAgreementData(filtered);
    } else {
      agreementData.push(data);
    }
    if (agreementIds.includes(data.id)) {
      setAgreementIds(agreementIds.filter((i) => i !== data.id));
    } else {
      agreementIds.push(data.id);
    }
    if (ids.includes(e.target.name)) {
      setIds(ids.filter((i) => i !== e.target.name));
    } else {
      setIds([...ids, e.target.name]);
    }
  };

  const columns = [
    {
      field: "initiateDate",
      headerName: "Initiate Date",
      minWidth: 110,
      flex: 1,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 90,
      flex: 1,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "code",
      headerName: "Code",
      minWidth: 90,
      flex: 1,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "branch_code",
      headerName: "Branch Code",
      minWidth: 180,
      flex: 1,
      type: "number",
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Landlord Name",
      minWidth: 160,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "location",
      headerName: "Location",
      minWidth: 160,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "address",
      headerName: "Address",
      minWidth: 160,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "city",
      headerName: "City",
      minWidth: 160,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },

    {
      field: "state",
      headerName: "State",
      minWidth: 200,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "manager_name",
      headerName: "Manager",
      minWidth: 160,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "srm_name",
      headerName: "Sr Manager",
      minWidth: 160,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "buh",
      headerName: "BUH",
      minWidth: 160,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "op_name",
      headerName: "Operations",
      minWidth: 160,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "deposit",
      headerName: "Deposit Amount",
      minWidth: 200,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "payable_deposit",
      headerName: "Deposit Payable",
      minWidth: 200,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "rentalAmount",
      headerName: "Rent Amount",
      minWidth: 200,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
    },
    {
      field: "view",
      headerName: "View",
      minWidth: 250,
      flex: 1,
      headerClassName: "dataGridHeader",
      headerAlign: "center",
      renderCell: renderDetailsButton,
    },
    // {
    //   field: "action",
    //   headerName: "Action",
    //   minWidth: 250,
    //   flex: 1,
    //   headerClassName: "dataGridHeader",
    //   headerAlign: "center",
    //   renderCell: renderActionButton,
    // },
  ];

  const [remarkOpen, setRemarkOpen] = useState(false);

  const [remarkMSG, setRemarkMSG] = useState("");

  function handleSend() {
    if (remarkMSG?.length > 0) {
      const uniqueObjects = agreementData.filter((item, index, self) => {
        return self.findIndex((obj) => obj?.code === item?.code) === index;
      });

      uniqueObjects.map(async (data, i) => {
        const response = await ApprovedByFinance(
          {
            status: "Approved",
            finance_id: srm_id,
            modify_date: new Date(),
            additionalRemark: {
              remarks: remarkMSG,
              step_name: auth.name,
              user_id: auth.id,
              agreement_code: data.code,
              agreement_id: data.i,
              modified_date: new Date(),
            },
          },
          data.i,
          role,
          subType
        );

        if (response?.data?.success) {
          await notification_handler("AG15", data.i, data.code, auth.id);
          dispatch(
            setAlert({
              variant: "success",
              open: true,
              message: "Approved ",
            })
          );
          setRemarkOpen(false);
          setIds([]);
          dispatch(setRefreshBox());
        } else if (response.status === 201) {
          dispatch(
            setAlert({
              variant: "error",
              open: true,
              message: response.data.message,
            })
          );
        } else {
          dispatch(
            setAlert({
              variant: "error",
              open: true,
              message: "Something went wrong! Please again later.",
            })
          );
        }
      });
    } else {
      dispatch(
        setAlert({
          variant: "error",
          open: true,
          message: "Remark Required",
        })
      );
    }
  }

  const handleConfirm = async (e) => {
    // return 1
    const response = await Add_utr_datails(
      {
        utr_number: utr.utr,
        payment_date: utr.paymentDate,
      },
      agreement?.id
    );
    // 321,84
    if (response.data.success) {
      // settled all the unpaid entries to paid one

      //Update Status
      if (agreement?.type === "Migrated") {
        await ApprovedByFinance(
          {
            status: "Deposited",
          },
          agreement?.i,
          auth.role,
          "Migrated" // agreement id
        );

        const monthlyRentStatus = await updateMigrateAgreement(
          agreement?.i,
          "Migrated"
        );
      }

      const popilateData = await populate_rent_data(agreement.i);
      //const res2 = await convertToPaid(code)

      setRows((old) =>
        rows.map((data) => {
          if (data.id === open.id) {
            data.utr_number = utr.utr;
            return data;
          } else return data;
        })
      );
      setUtr({ utr: "", paymentDate: "" });
      setopen({ open: false });

      dispatch(
        setAlert({
          variant: "success",
          open: true,
          message: "UTR Details Added",
        })
      );
      window.location.reload();
      const notification = await notification_handler(
        "AG19",
        agreement?.i,
        agreement?.code,
        auth.id,
        agreement?.id
      );
    } else {
      dispatch(
        setAlert({
          variant: "error",
          open: true,
          message: "Something went wrong! Please again later.",
        })
      );
    }
  };
  return (
    <>
      <DialogBoxSBM
        open={open.open}
        handleClose={() => {
          setopen({ ...open, open: false });
          setUtr({ utr: "", paymentDate: "" });
        }}
        handleConfirm={handleConfirm}
        value={utr}
        setValue={setUtr}
        modifyDate={modifyDate}
      />

      {ids.length > 0 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            sx={{ textTransform: "capitalize", m: 1, mx: 3 }}
            onClick={() => setRemarkOpen(true)}
          >
            Approve
          </Button>
        </Box>
      )}
      <Remark
        setIds={setIds}
        remark={remarkMSG}
        setRemark={setRemarkMSG}
        handleSend={handleSend}
        open={remarkOpen}
        handleClose={() => {
          setRemarkOpen(false);
          window.location.reload();
        }}
      />

      <Box
        sx={{
          height: "430px",
          px: 2,
          "& .dataGridHeader": {
            color: "#CACACA",
            textAlign: "left",
          },
          "& .green": {
            backgroundColor: "#E7FFE9",
            color: "#41CF2A",
          },
          "& .yellow": {
            backgroundColor: "#FEFFC8",
            color: "#C5C05B",
          },
          "& .red": {
            backgroundColor: "#FFEBE7",
            color: "#CF482A",
          },
          "& .statusCell": {
            // maxWidth:"180px !important",
            // minWidth:"92px !important",
            maxHeight: "30px !important",
            minHeight: "25px !important",
            alignSelf: "center",
            mx: 1,
            textAlign: "center !important",
            borderRadius: "10px !important",
          },
          "& .allCell": {
            justifyContent: "center !important",
          },
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={6}
          rowsPerPageOptions={[6]}
          // checkboxSelection
          sx={{ color: "black !important", minWidth: "50px" }}
          getCellClassName={(parms) => {
            let cellClass = [];
            if (
              parms.field === "status" &&
              (parms.row.status === "Approved" ||
                parms.row.status === "Deposited")
            ) {
              cellClass.push("green statusCell");
            } else if (
              parms.field === "status" &&
              (parms.row.status === "Sent To Sr Manager" ||
                parms.row.status === "Sent To BUH" ||
                parms.row.status === "Sent To Operations" ||
                parms.row.status === "Sent To Finance Team" ||
                parms.row.status === "Draft")
            ) {
              cellClass.push("yellow statusCell");
            } else if (
              parms.field === "status" &&
              (parms.row.status === "Sent Back From Sr Manager" ||
                parms.row.status === "Sent Back From BUH" ||
                parms.row.status === "Sent Back From Operations" ||
                parms.row.status === "Sent Back From Finance Team" ||
                parms.row.status === "Terminated By Manager" ||
                parms.row.status === "Terminated By Sr Manager" ||
                parms.row.status === "Terminated By Operations" ||
                parms.row.status === "Approved for Termination" ||
                parms.row.status ===
                  "Sent Back From Finance Team Termination" ||
                parms.row.status === "Terminated")
            ) {
              cellClass.push("red statusCell");
            }
            cellClass.push("allCell");

            return cellClass;
          }}
          // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
        ></DataGrid>
      </Box>
    </>
  );
}

export default SuperAdminTable;
